module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "item-description"
  }, [_c('div', {
    staticClass: "description-title",
    class: {
      'description-title-bold': _vm.largeTitle
    }
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.item.description))]), _vm._v(" "), _c('div', {
    staticClass: "item-number"
  }, [_vm._v("\n    Item # " + _vm._s(_vm.item.id) + "\n    "), (_vm.orderInfo) ? _c('span', {
    staticClass: "item-order"
  }, [_vm._v(", " + _vm._s(_vm.item.quantity) + " Qty @ " + _vm._s(_vm._f("currency")(_vm.item.price)) + " Ea")]) : _vm._e()]), _vm._v(" "), _c('detail-modal', {
    attrs: {
      "item": _vm.item
    }
  }, [_vm._v("Details")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bab03e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/item-description.vue
// module id = 759
// module chunks = 1